import { Button } from '@abyss/web/ui/Button';
import { Flex } from '@abyss/web/ui/Flex';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import { Text } from '@abyss/web/ui/Text';
import React from 'react';

import { adobeLinkTrackEvent } from '../../../../common/AdobeTagging/adobeLinkTrackEvent';
import { DividerStyle, LayoutGroupStyled } from './CompareSmartChoice.styled';

export const CompareFooter = ({
  removeItem,
  removeButtonText,
  filteredProviders,
}) => (
  <>
    <LayoutGroupStyled cssProps={{ minHeightAuto: true }} grow>
      {filteredProviders?.map((_, index) => (
        <React.Fragment key={index}>
          <DividerStyle />
        </React.Fragment>
      ))}
    </LayoutGroupStyled>
    <LayoutGroupStyled
      css={{ '& > div': { width: '100%', justifyContent: 'center' } }}
      cssProps={{ minHeightAuto: true }}
      grow
    >
      {filteredProviders?.map((provider, index) => (
        <Flex justify="center" key={index}>
          <Flex
            alignItems="center"
            data-auto-testid={`removed-provider-${provider?.locationId}`}
            data-testid={`removed-provider-${provider?.locationId}`}
            justify="center"
            onClick={() => {
              adobeLinkTrackEvent({
                name: 'Remove',
                location: 'Compare providers successful',
                type: 'Internal',
              });
              removeItem(provider?.locationId);
            }}
          >
            <Button color="destructive" size="$sm" variant="ghost">
              <IconSymbol
                color="$error1"
                css={{
                  fontWeight: '$bold',
                  border: '2px solid $error1',
                  borderRadius: '50%',
                }}
                icon="close"
                size={14}
              />
              <Text
                css={{
                  fontWeight: '$semibold',
                  color: '$error1',
                  cursor: 'pointer',
                  marginLeft: '$xs',
                }}
              >
                {removeButtonText}
              </Text>
            </Button>
          </Flex>
        </Flex>
      ))}
    </LayoutGroupStyled>
  </>
);
